import cep from '@/pages/catalog/[...catalog_query]/CatalogExplorerPage.module.scss';
import { Flex } from 'antd';
import { CatalogQueryService } from '@/utils/services/CatalogQueryService';
import Image from 'next/image';
import icon_catalog_filtercross from '/public/static/images/icon_catalog_filtercross.svg';
import React from 'react';
import { useRouter } from 'next/router';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';

const CatalogFiltersTags = ({ catalogType, filterItems }: any) => {
    const router = useRouter();
    const LOCALIZATION = useLocalization();

    return (
        <Flex className={cep.filterRow}>
            {catalogType?.filter_params?.map((filter: any) => {
                if (filterItems.find((f: any) => f.name === filter.property))
                    return (
                        <Flex
                            onClick={() => {
                                CatalogQueryService.remove(catalogType, filter);
                                router.push({
                                    pathname: CatalogQueryService.build(catalogType),
                                });
                            }}
                            className={cep.filterRowItem}
                        >
                            <span className={`text-14-400 ${cep.filterRowItem__text}`}>
                                {filterItems.find((f: any) => f.name === filter.property).alias}:{' '}
                                <span>
                                    {filter.values.length === 1 ? (
                                        filter.values[0]
                                    ) : (
                                        <span>
                                            {filter.values[0]}{' '}
                                            <span className={cep.filterRowItem__text__count}>
                                                +{filter.values.length}
                                            </span>
                                        </span>
                                    )}
                                </span>
                            </span>
                            <Image
                                className={cep.filterRowItem__button}
                                src={icon_catalog_filtercross}
                                alt={''}
                                height={0}
                                width={0}
                                sizes={'100%'}
                            />
                        </Flex>
                    );
            })}
            <Flex
                onClick={() => {
                    CatalogQueryService.clear(catalogType);
                    router.push({
                        pathname: CatalogQueryService.build(catalogType),
                    });
                }}
                className={cep.filterRowItem}
            >
                <span className={`text-14-400 ${cep.filterRowItem__text}`}>
                    {LOCALIZATION.pages.catalog.catalogQuery.clearAll}
                </span>
                <Image
                    className={cep.filterRowItem__button}
                    src={icon_catalog_filtercross}
                    alt={''}
                    height={0}
                    width={0}
                    sizes={'100%'}
                />
            </Flex>
        </Flex>
    );
};

export default CatalogFiltersTags;
